import { PrintSummarySheetButton, PrintSummarySheet } from './types';

export const usePrintSummarySheet = ({
  intl,
  printSummarySheetTitle,
  columnDefs,
  selectedVendors
}: PrintSummarySheetButton): PrintSummarySheet => {
  const openPrintSummarySheet = () => {
    const mywindow = window.open('/', '_blank', 'width=800, height=600');
    if (mywindow) {
      mywindow.document.write(
        `<html><head><h3><title>${intl.formatMessage(
          printSummarySheetTitle
        )}</title></h3>`
      );
      mywindow.document.write(`</head><body >`);
      mywindow.document.write(
        `<table style="width:100%; text-align:center" border="1" cellpadding="10"><thead>`
      );
      columnDefs.forEach(({ headerName }) => {
        mywindow.document.write(`
                                <th>
                                ${String(headerName)}
                                 </th>
                               `);
      });

      mywindow.document.write(`</thead><tbody>`);
      if (selectedVendors?.length) {
        selectedVendors.forEach(({ vendorNo, vendorName, totalNetAmount }) => {
          mywindow.document.write(`<tr>`);
          mywindow.document.write(
            `<td>${vendorNo} </td> <td>${vendorName} </td> <td>${totalNetAmount} </td>`
          );
          mywindow.document.write(`</tr>`);
        });
      }
      mywindow.document.write(`</tbody></table>`);
      mywindow.document.write(`</body></html>`);
      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    }
  };
  return { openPrintSummarySheet };
};
